import { useCallback } from 'react';

import { type AIJobNotificationContext, useAIJobNotificationStore } from 'stores/aiJobNotificationStore';

type TrackAIJobInput = Omit<AIJobNotificationContext, 'createdAt'>;

export const useTrackAIJob = () => {
  const { trackAIJob, trackedJobs } = useAIJobNotificationStore();

  const startTracking = useCallback(
    (context: TrackAIJobInput) => {
      const fullContext: AIJobNotificationContext = {
        ...context,
        createdAt: new Date(),
      };

      // The AIJobNotificationManager will detect this and manage notifications
      trackAIJob(fullContext);
    },
    [trackAIJob]
  );

  const isTracking = useCallback(
    (jobId: string) => {
      return trackedJobs.has(jobId);
    },
    [trackedJobs]
  );

  return { startTracking, isTracking };
};
